import { useOutletContext } from 'hooks/useOutletContext';

import UsersTableDefault from './UsersTableDefault';
import { type UserTableDefaultProps } from './UsersTableDefault/ui/view';
import { UsersTableManagement } from './UsersTableManagement/UsersTableManagement';

export type UsersTableProps = UserTableDefaultProps;

export const UsersTable = (props: UsersTableProps) => {
  const user = useOutletContext();

  if (user.role === 'BIZDEV' || user.role === 'MANAGER') return <UsersTableManagement />;

  return <UsersTableDefault {...props} />;
};
